import React, {Component} from 'react';

import ContainerHeader from 'components/ContainerHeader/index';
import CardBox from 'components/CardBox/index';
import { Button } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';
import ModuleNewFolder from './ModuleNewFolder';


class NewFolder extends Component {
  render() {
    return (
      <div>
        <ContainerHeader title={"Nuova Cartella"} match={this.props.match}/>

       
        <NavLink to="/app/folders">
        <Button className="void">
                <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />

                <span className="nav-text">Indietro</span>

              </Button>
         
        </NavLink>
        <div  className="form-group">
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>


        <div className="row">

        
         <ModuleNewFolder></ModuleNewFolder>
        </div>
      </div>
    )
  }
}

export default NewFolder;
